import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_19 = ["disabled", "placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_26 = {
  key: 0,
  class: "col-12"
}
const _hoisted_27 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_28 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_29 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_31 = { class: "position-relative" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "row justify-content-center" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" CAREGIVER INFO "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t('form.section.caregiver_information')), 1 /* TEXT */)
            ]),
            _createCommentVNode(" FIRST NAME "),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('form.first_name.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.caregiver.firstname) = $event)),
                  required: "",
                  type: "text",
                  class: _normalizeClass([[{ 'is-invalid': _ctx.submitted && _ctx.errors?.firstname }], "form-control shadow-none text-black"]),
                  placeholder: _ctx.$t('form.first_name.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_9), [
                  [_vModelText, _ctx.caregiver.firstname]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.firstname ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.firstname, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" LAST NAME "),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('form.last_name.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.caregiver.lastname) = $event)),
                  required: "",
                  type: "text",
                  class: _normalizeClass([[{ 'is-invalid': _ctx.submitted && _ctx.errors?.lastname }], "form-control shadow-none text-black"]),
                  placeholder: _ctx.$t('form.last_name.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_14), [
                  [_vModelText, _ctx.caregiver.lastname]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.lastname ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.lastname, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" EMAIL "),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.caregiver.email) = $event)),
                  disabled: _ctx.update,
                  class: _normalizeClass([[{ 'is-invalid': _ctx.submitted && _ctx.errors?.email }], "form-control shadow-none text-black"]),
                  pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                  type: "email",
                  placeholder: _ctx.$t('form.email.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_19), [
                  [_vModelText, _ctx.caregiver.email]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.email ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.email, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" PHONE "),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.caregiver.phone_number) = $event)),
                  type: "text",
                  class: _normalizeClass([[{ 'is-invalid': _ctx.submitted && _ctx.errors?.phone_number }], "form-control shadow-none text-black"]),
                  placeholder: _ctx.$t('form.phone.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_24), [
                  [_vModelText, _ctx.caregiver.phone_number]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.phone_number ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.phone_number, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createCommentVNode(" DELETE "),
                    (_ctx.update && _ctx.destroyEnabled)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('cta.delete_caregiver')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_32)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("button", {
                      class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                      type: "submit",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitted = true))
                    }, _toDisplayString(_ctx.update ? _ctx.$t('cta.save_caregiver') : _ctx.$t('cta.add_caregiver')), 1 /* TEXT */)
                  ])
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteCaregiver())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}